import type { PokerHomeGames } from '@ps/web-martech-cms-types';
import type {
  ClubIdRequest,
  GetScheduledRingGamesResponse
} from '@ps/web-shared-api-types/v1-preview/SwHomeGames';

import type { ExtractDispatchFromModel, WidgetEffectParams } from '@swf/core/store';
import type { HomeGamesWidgetModel } from '@swf/poker';
import { ENDPOINTS, PKR_LOADERS } from '@swf/poker';

export const fetchScheduledRingGames = async (
  { clubId, polling }: { clubId?: number; polling?: boolean } = {},
  { request, dispatch, widget: { uid } }: WidgetEffectParams<PokerHomeGames>
) => {
  const widgetDispatch: ExtractDispatchFromModel<HomeGamesWidgetModel> = dispatch[uid];
  const loaderName = PKR_LOADERS.scheduledTables;
  widgetDispatch.setLoading({ isLoading: true, loaderName });

  const body: ClubIdRequest & { polling: boolean | undefined } = { clubId, polling };

  try {
    const {
      body: { success, scheduledRingGamesReply }
    } = await request<GetScheduledRingGamesResponse>({
      service: ENDPOINTS.scheduledRingGames,
      body,
      http: true
    });

    if (success && scheduledRingGamesReply?.ringGames) {
      widgetDispatch.setScheduledRingGames({
        response: scheduledRingGamesReply?.ringGames
      });
    }
  } catch (error) {
    widgetDispatch.setLoading({ isLoading: false, loaderName });
  } finally {
    widgetDispatch.setLoading({ isLoading: false, loaderName });
  }
};
